<template>
  <div class="analytic-unit-block-loader">
    <content-loader
      :height="300"
      :width="500"
      :speed="2"
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
    >
      <rect x="33" y="18.61" rx="3" ry="3" width="391.85" height="24.36" />
      <rect x="34" y="54.4" rx="3" ry="3" width="430.5" height="7.38" />
      <rect x="32" y="81" rx="3" ry="3" width="56.28" height="59.64" />
      <circle cx="459.68" cy="32.7" r="11.7" />
      <rect x="107.56" y="79.61" rx="0" ry="0" width="364" height="22" />
      <rect x="414.56" y="85.61" rx="0" ry="0" width="0" height="0" />
      <rect x="107.56" y="118.61" rx="0" ry="0" width="364" height="22" />
      <rect x="32.56" y="190" rx="0" ry="0" width="435" height="93" />
    </content-loader>
  </div>
</template>
<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  name: 'AnalyticsUnitBlockLoader',
  components: {
    ContentLoader,
  },
};
</script>


// WEBPACK FOOTER //
// AnalyticsUnitBlockLoader.vue?7e7ef35e